import { coreService } from "../../../services";

const forgotPassword = async (email: string): Promise<void> => {
  await coreService.httpClient.post("/auth/forgot-password", { email });
};

export { forgotPassword };
